import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input, OnChanges, OnInit, Output, SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import {AgentReference} from "../../../../agents/angular/models/agentReference.model";
import {TaskModel} from "../../../../tasks/models/task.model";

require('./agent-routes-performance-row.scss');
@Component({
  standalone: false,
  selector: 'app-agent-routes-performance-row',
  templateUrl: './agent-routes-performance-row.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentRoutesPerformanceRowComponent implements OnInit, OnChanges {
  @Input() route: any;
  @Input() isAllowViewRouteTasks: boolean;

  @Output() viewTasksEvent = new EventEmitter<{
    tasks: TaskModel[], routeName: string, plannedTasksOrder: string[],
    actualTasksOrder: string[]
  }>();

  public geoEnterTime: any;
  public geoExitTime: any;

  ngOnInit() {
    if (!!this.route.actualTasksOrder?.length) {
      this.geoEnterTime = this.route.routeTasks?.find(task => task.id === this.route.actualTasksOrder[0])?.geofenceEventDataSegment?.startEntry;
      this.geoExitTime = this.route.routeTasks?.find(task => task.id === this.route.actualTasksOrder[this.route.actualTasksOrder.length - 1])?.geofenceEventDataSegment?.endEntry;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agentRouteScore && !changes.agentRouteScore.isFirstChange()) {
      if (!!this.route.actualTasksOrder?.length) {
        this.geoEnterTime = this.route.routeTasks?.find(task => task.id === this.route.actualTasksOrder[0])?.geofenceEventDataSegment?.startEntry;
        this.geoExitTime = this.route.routeTasks?.find(task => task.id === this.route.actualTasksOrder[this.route.actualTasksOrder.length - 1])?.geofenceEventDataSegment?.endEntry;
      }
    }
  }

  onViewRouteTasks() {

    // const actualTasksOrder = [...this.route.routeTasks].sort((a, b) => this.route.actualTasksOrder.indexOf(a.id) - this.route.actualTasksOrder.indexOf(b.id));

    if (this.isAllowViewRouteTasks) {
      this.viewTasksEvent.emit({
        tasks: this.route.routeTasks,
        routeName: this.route.routeName,
        actualTasksOrder: this.route.actualTasksOrder,
        plannedTasksOrder: this.route.plannedTasksOrder
      });
    }
  }
}
